import { Component } from '@angular/core';
import { VideoDetail } from './videos';

@Component({
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss'],
  standalone: false
})
export class VideosComponent {
  public videos: VideoDetail[] = [
    {
      name: 'Úvodní video “O BWM”',
      url: 'https://cloud.bcas.cz/video/investicni_sjednavac/FULLHD/G-fWD4R8CSPsSGyGxTtsCDsXuL2rTkUgrR.mp4',
    },
  ];
}
